@if (batch()) {
  ⏳
} @else {
  ...
}
